import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=b54f5e10"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b54f5e10')) {
      api.createRecord('b54f5e10', component.options)
    } else {
      api.reload('b54f5e10', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=b54f5e10", function () {
      api.rerender('b54f5e10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/Menu.vue"
export default component.exports